import React from 'react';
import { useTranslation } from '../../../i18n';
import './PlanYourTripButton.css';

interface PlanYourTripButtonProps {
  onClick?: () => void;
  property?: 'brand' | 'atacama' | 'iguazu' | 'mendoza' | 'patagonia' | 'santa-catarina' | 'awasi';
}

export const PlanYourTripButton: React.FC<PlanYourTripButtonProps> = ({
  onClick,
  property = 'awasi'
}) => {
  const { t } = useTranslation();

  return (
    <a
      href="#plan-your-trip"
      className={`plan-your-trip-link plan-your-trip-link--${property}`}
      onClick={onClick}
    >
      {t('common:buttons.planYourTrip')}
      <img className="plan-your-trip-link__background" />
    </a>

  );
};